<template>
	<TheButton v-if="hasPreviousRoute" text class="button--back" @buttonclick="goBack">
		<el-icon><ArrowLeft /></el-icon>Zurück
	</TheButton>
</template>

<script>
import TheButton from '../TheButton.vue';
import { ArrowLeft } from '@element-plus/icons-vue';

export default {
	name: 'ButtonBack',
	components: {
		TheButton,
		ArrowLeft,
	},
	data() {
		return {
			hasPreviousRoute: false,
		};
	},
	mounted() {
		this.checkPreviousRoute();
	},
	methods: {
		checkPreviousRoute() {
			// Button soll nicht gezeigt werden, wenn es keine vorherige Route gibt (Direkter Link aus Email z.B.)
			this.hasPreviousRoute = this.$router.options.history.state.back !== null;
		},
		goBack() {
			if (this.hasPreviousRoute) {
				this.$router.back();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.button--back.is-round {
	text-decoration: underline;
	margin-bottom: 1rem;

	.el-icon {
		font-size: 0.7rem;
	}
}
</style>
